import { render, staticRenderFns } from "./UserGroupForm.vue?vue&type=template&id=0080a7e4&scoped=true"
import script from "./UserGroupForm.vue?vue&type=script&lang=js"
export * from "./UserGroupForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0080a7e4",
  null
  
)

export default component.exports